import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import VendorProductTable from './VendorProductTable';
import BulkEditVendorProductsView from './BulkEditVendorProductsView';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import VendorProductDetailsView from './VendorProductDetailsView';
import ExternalProductImportViews from '../external/ExternalProductImportViews';
import VendorProductDesignView from './VendorProductDesignView';

const VendorProductsView = () => {
  const { state: authState } = useContext(AuthContext);
  const { state, fetchVendorCollections } = useContext(VendorContext);

  useEffect(() => {
    if (
      authState.pkEcomVendor &&
      (!state.ecomVendorCollections.lastUpdated ||
        state.ecomVendorCollections.filter?.fkEcomVendor !==
          authState.pkEcomVendor)
    ) {
      fetchVendorCollections({ fkEcomVendor: authState.pkEcomVendor });
    }
  }, [authState.pkEcomVendor]);

  return (
    <Routes>
      <Route
        element={<ExternalProductImportViews />}
        path="/import/:configRouteValue/*"
      />
      <Route element={<VendorProductDesignView />} path="/design/*" />
      <Route element={<BulkEditVendorProductsView />} path="/bulk-edit" />
      <Route element={<VendorProductDetailsView newProduct />} path="/new" />
      <Route
        element={<VendorProductDetailsView />}
        path="/:ecomVendorProductUuid/*"
      />
      <Route element={<VendorProductTable />} path="/" />
      <Route element={<Navigate replace to="/vendor/products" />} path="*" />
    </Routes>
  );
};

export default VendorProductsView;
